<template>
    <div class="upload-img">
        <!--上传图片-->
        <el-upload
            class="upload-demo"
            ref="upload"
            :multiple="multiple"
            :name="name"
            :drag="drag"
            :data="sendData"
            :accept="accept"
            :action="url"
            :headers="headers"
            :list-type="listType"
            :file-list="fileList"
            :limit="limit"
            :before-upload="beforeHandle"
            :on-success="handleSuccess"
            :on-error="handleError"
            :before-remove="handleRemove">
            <i class="el-icon-plus"></i>
        </el-upload>
    </div>
</template>

<script>
    import {FILE_UPLOAD_URL} from "@/configs/configs";

    export default {
        name: "UploadImg",
        props: {
            //如果有多个组件，组件的索引
            index: {
                type: Number,
                default: 1
            },
            //图片的默认初始地址
            imgurl: {
                type: String,
                default: ''
            },
            //是否支持多文件上传
            multiple: {
                type: Boolean,
                default: false
            },
            //是否支持文件拖拽上传
            drag: {
                type: Boolean,
                default: false
            },
            //上传的文件域字段名称
            name: {
                type: String,
                default: 'files'
            },
            //接收的上传文件类型，默认为图片类型
            accept: {
                type: String,
                default: 'image/*'
            },
            //文件列表的展示样式，有text/picture/picture-card三种类型
            listType: {
                type: String,
                default: 'picture-card'
            },
            //最大允许上传个数
            limit: {
                type: Number,
                default: 1
            },
            //请求附加参数
            data: {
                type: Object,
                default: null
            },
            //请求头参数
            headers: {
                type: Object,
                default: function() {
                    return null;
                }
            },
            //允许上传文件的大小，单位为字节,默认值为4Mb
            limitSize: {
                type: Number,
                default: 1024 * 1024 * 6
            },
            //允许上传的文件格式后缀,多个请以英文逗号隔开
            fileExtension: {
                type: String,
                default: 'jpg,png,jpeg,gif'
            }
        },
        computed: {
            sendData() {
                let data = {
                    limit: this.limitSize,
                    types: this.fileExtension
                };
                if(this.data) {
                    return Object.assign(data, this.data);
                };
                return data;
            },
        },
        data() {
            return {
                url: FILE_UPLOAD_URL,
                fileList: [],
                //上传成功的一个映射表
                loadList: []
            };
        },
        watch: {
            imgurl(newVal) {
                if(newVal) {
                    let arr = newVal.split(';');
                    arr.forEach(item => {
                      if(item) {
                        this.fileList.push({
                          name: '',
                          url: item
                        });
                      }
                    });

                    //初始化loadList
                    setTimeout(() => {
                      this.fileList.forEach(item => {
                        if(item) {
                          this.loadList.push({
                            uid: item.uid,
                            url: item.url
                          });
                        }
                      });
                    }, 50);
                }
            }
        },
        methods: {
            submitUpload() {
                //点击上传按钮后将现在的图片清除
                this.$emit('remove', {
                  index: this.index
                });

                //发送请求
                this.$refs.upload.submit();
            },
            beforeHandle(file) {
                //文件上传前的回调
                if(file && file.name && file.name.trim() && file.size) {
                    //看父组件是否传递了允许上传的文件格式后缀
                    if(!!this.fileExtension) {
                        //检测文件后缀
                        if(!this.checkFileType(file.name)) {
                            this.msg('不允许上传该格式文件', 2);
                            return false;
                        };
                    };

                    //检测文件大小是否已经超过限制
                    if(parseInt(file.size) > this.limitSize) {
                        this.msg('上传图片不超过6M', 2);
                        return false;
                    }

                    //验证通过
                    return true;
                }
                return false;
            },
            handleSuccess(res, file, fileList) {
                if(res && (res.code === 200) && res.data && res.data.url) {
                    //添加到队列
                    this.loadList.push({
                      uid: file.uid,
                      url: res.data.url
                    });
                    //上传成功，注册父组件的成功事件
                    this.$emit('success', {
                        url: res.data.url,
                        index: this.index
                    });
                } else {
                    //图片上传失败
                    this.msg(`${file.name}上传失败`, 3);
                };
            },
            //上传出错
            handleError(err, file) {
                if(err) {
                    //注册失败事件
                    this.$emit('fail', file);
                    this.msg(`${file.name}上传失败`);
                };
            },
            //移除文件
            handleRemove(file, fileList) {
                //移除文件
                let url = '';
                if(file && file.uid && this.loadList.length) {
                  //遍历查找
                  let obj = this.loadList.find(item => {
                    return item.uid === file.uid;
                  });
                  url = (obj && obj.url) || '';
                }
                this.$emit('remove', {
                  url: url,
                  index: this.index
                });
            },

            //文件类型检测
            checkFileType(fileName) {
                const typeArr = this.fileExtension.split(',');
                let name = fileName.trim().toLowerCase()
                if(typeArr.length && name) {
                    if(!typeArr.some((res) => {
                        return name.endsWith(res);
                    })) {
                        return false;
                    }
                }
                return true;
            }
        }
    }
</script>

<style scoped>

</style>